/*@ngInject*/
const AccountSubmissionsGridRepository = function (baseRepository) {

    angular.extend(this, baseRepository);

    this.loadSubmissions = function (accountId, accountNumber, submissionParams) {
        let url = '/rest/Account/submissions',
            config = {
                params: {
                    accountId: accountId,
                    accountNumber: accountNumber,
                    sortBy: submissionParams.key,
                    sortDirection: submissionParams.sortType,
                    startIndex: submissionParams.startIndex,
                    numberOfRows: submissionParams.pageSize
                }
            };

        return this.get(url, config);
    };

};

angular.module('gw-um-submission')
    .service('accountSubmissionsGridRepository', AccountSubmissionsGridRepository);
